import styled from "@emotion/styled";

import { ThemeMode } from "../../../context/ThemeContext";

export const AppHeaderWrapper = styled.header<{
  mode: ThemeMode;
  isPanoramicResults?: boolean;
}>`
  box-sizing: border-box;
  padding: 24px 0;
  background: ${(props) => (props.mode === "dark" ? "#1F242A" : "#ffffff")};

  .logo {
    display: flex;
    align-items: center;
    height: 25px;
  }
  .header {
    height: 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    menu {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      list-style-type: none;
      li {
        margin-right: 22px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
  }
`;
